import React from "react";
import Text from "../../components/typography/Text";
import SignUpContext from "../../contexts/signUp";
import Button from "../../components/buttons/Button";
import EnvelopeSVG from "../../images/illustrations/envelope.svg";
import useApi from "../../hooks/useApi";
import fetchApi from "../../fetchApi";
import Notice from "../../components/notice/Notice";
export default () => {
  const {
    data: { email, role },
  } = React.useContext(SignUpContext);

  const [notice, setNotice] = React.useState();

  const { data: siteOptions, loading } = useApi("/options");

  const resendActivation = async () => {
    try {
      const result = await fetchApi(`/users/activation`, {
        method: "post",
        body: { email },
      });
      if (result.success) {
        setNotice({ type: "success", message: result.message });
      } else {
        setNotice({ type: "error", message: result.message });
      }
      return result;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  if (loading) return null;

  return (
    <div className="pSignUp -verify">
      <img src={EnvelopeSVG} alt="Verify" />
      <h4>{siteOptions["confirmation_message_" + role].title}</h4>
      <Text>{siteOptions["confirmation_message_" + role].content}</Text>
      <Text small>Mail sent to {email}</Text>
      {notice && <Notice type={notice.type}>{notice.message}</Notice>}
      <Button outlined rounded onClick={resendActivation}>
        Resend email
      </Button>
    </div>
  );
};
